import { HelpView } from "@/admin/settings/HelpView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/help")({
    component: HelpView,
});
